module.exports = __webpack_public_path__ + "img/uw_logo_dark.42e601fe.svg";